import * as colors from 'src/themes/brickx/colors';

const theme = {
  colors,
};

export default theme;
